var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEgg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 40,
    viewBox: "0 0 30 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8052 2.39412e-05C25.384 -0.0234995 32.0591 17.2931 29.4245 28.2685C27.0937 37.9871 20.3985 40 15.039 40C9.67949 40 3.17131 37.3855 0.653515 28.6449C-2.25831 18.5231 4.93443 0.0235474 14.8052 2.39412e-05Z",
    fill: "#F2A05B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.73418 8.24015C5.46527 10.28 4.18634 12.8474 3.91252 14.988C3.41164 18.9299 6.29341 19.3735 7.29852 17.4177C8.30363 15.4619 9.33212 13.4825 10.965 10.858C13.2223 7.232 16.9189 4.80236 15.1023 3.22629C13.2858 1.65022 9.3989 3.95216 6.73418 8.24015Z",
    fill: "#FECC88"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1451 13.8218C24.5176 13.8218 24.8196 13.5119 24.8196 13.1296C24.8196 12.7473 24.5176 12.4373 24.1451 12.4373C23.7726 12.4373 23.4706 12.7473 23.4706 13.1296C23.4706 13.5119 23.7726 13.8218 24.1451 13.8218Z",
    fill: "#D47858"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9036 30.371C25.0573 29.9951 24.8804 29.5657 24.5086 29.4117C24.1368 29.2578 23.7108 29.4378 23.5572 29.8137C23.4035 30.1896 23.5804 30.6191 23.9522 30.773C24.324 30.9269 24.75 30.7469 24.9036 30.371Z",
    fill: "#D47858"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.24294 33.3166C5.38605 32.9665 5.22 32.5659 4.87206 32.4218C4.52413 32.2778 4.12605 32.4449 3.98294 32.7951C3.83983 33.1452 4.00588 33.5458 4.35381 33.6899C4.70175 33.8339 5.09982 33.6668 5.24294 33.3166Z",
    fill: "#D47858"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6474 20.3149C27.1501 20.0528 27.3718 19.4796 27.1427 19.0347C26.9137 18.5898 26.3204 18.4416 25.8177 18.7037C25.315 18.9659 25.0933 19.5391 25.3223 19.984C25.5514 20.4289 26.1447 20.5771 26.6474 20.3149Z",
    fill: "#D47858"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9203 29.3354C17.4229 29.0732 17.6447 28.5 17.4156 28.0551C17.1865 27.6102 16.5933 27.462 16.0906 27.7242C15.5879 27.9863 15.3661 28.5595 15.5952 29.0044C15.8243 29.4494 16.4176 29.5975 16.9203 29.3354Z",
    fill: "#D47858"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.965 34.1086C16.3364 33.6399 16.3219 33.0067 15.9326 32.6942C15.5433 32.3818 14.9266 32.5084 14.5552 32.9771C14.1838 33.4458 14.1983 34.079 14.5876 34.3915C14.9769 34.7039 15.5936 34.5772 15.965 34.1086Z",
    fill: "#D47858"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 35.2192C12.4209 34.7227 12.39 33.9743 11.9132 33.5476C11.4363 33.1209 10.6941 33.1774 10.2554 33.674C9.81665 34.1705 9.84756 34.9189 10.3244 35.3456C10.8012 35.7723 11.5435 35.7158 11.9822 35.2192Z",
    fill: "#D47858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEgg);
export default __webpack_public_path__ + "static/media/egg.b3f8841d2f14e3e2a1e8151dc8d6b31e.svg";
export { ForwardRef as ReactComponent };